import apiClient from './api';

export default {
    async getOrders(params = {}) {
        return (await apiClient.get('/orders', { params })).data;
    },

    async getOrder(id) {
        return (await apiClient.get(`/orders/${id}`)).data;
    },

    async createOrder(data) {
        return (await apiClient.post('/orders', data)).data;
    },

    async updateOrder(id, data) {
        return (await apiClient.put(`/orders/${id}`, data)).data;
    },

    async finalizeOrder(id) {
        // According to our analyst, we might need to hit a specific endpoint or update status
        return (await apiClient.put(`/orders/${id}`, { status: 'final' })).data;
    },

    async forceCloseOrder(id) {
        return (await apiClient.put(`/orders/${id}`, { status: 'completed' })).data;
    },

    async deleteOrder(id) {
        return (await apiClient.delete(`/orders/${id}`)).data;
    }
};
